var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuBtIcon01On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7916 41.6667L26.3249 37.9334C26.0721 37.8362 25.8339 37.7195 25.6103 37.5834C25.3867 37.4473 25.168 37.3014 24.9541 37.1459L21.4832 38.6042L18.2749 33.0625L21.2791 30.7875C21.2596 30.6514 21.2499 30.5202 21.2499 30.3938V29.6063C21.2499 29.4799 21.2596 29.3487 21.2791 29.2125L18.2749 26.9375L21.4832 21.3959L24.9541 22.8542C25.168 22.6987 25.3916 22.5528 25.6249 22.4167C25.8582 22.2806 26.0916 22.1639 26.3249 22.0667L26.7916 18.3334H33.2082L33.6749 22.0667C33.9277 22.1639 34.1659 22.2806 34.3895 22.4167C34.6131 22.5528 34.8318 22.6987 35.0457 22.8542L38.5166 21.3959L41.7249 26.9375L38.7207 29.2125C38.7402 29.3487 38.7499 29.4799 38.7499 29.6063V30.3938C38.7499 30.5202 38.7305 30.6514 38.6916 30.7875L41.6957 33.0625L38.4874 38.6042L35.0457 37.1459C34.8318 37.3014 34.6082 37.4473 34.3749 37.5834C34.1416 37.7195 33.9082 37.8362 33.6749 37.9334L33.2082 41.6667H26.7916ZM30.0582 34.0834C31.186 34.0834 32.1485 33.6848 32.9457 32.8875C33.743 32.0903 34.1416 31.1278 34.1416 30C34.1416 28.8723 33.743 27.9098 32.9457 27.1125C32.1485 26.3153 31.186 25.9167 30.0582 25.9167C28.911 25.9167 27.9437 26.3153 27.1562 27.1125C26.3687 27.9098 25.9749 28.8723 25.9749 30C25.9749 31.1278 26.3687 32.0903 27.1562 32.8875C27.9437 33.6848 28.911 34.0834 30.0582 34.0834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_3584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuBtIcon01On);
export default __webpack_public_path__ + "static/media/leftmenu_bt_icon01_on.9a75a6391cf0c5e038811f9f4e584c4a.svg";
export { ForwardRef as ReactComponent };